import {observer} from "mobx-react"
import {Component} from "react"
import cmsStore from "../stores/cmsStore"
import {Button, Icon} from "semantic-ui-react"
import React from "react"

@observer
export default class CMSIntegration extends Component {

	toggle = () => {
		cmsStore.toggleEditor()
	}

	render() {
		const {isEditor, useEditor} = cmsStore
		if (!isEditor) return null
		return (
			<div className="fixed bottom-1 left-1 " style={{zIndex: 889}}>
				{useEditor && <Button  className="animate fadeIn" size="tiny" title="Bearbeiten beenden" circular icon={"close"} onClick={this.toggle} />}
				{!useEditor && <Button className="animate fadeInLeft" size="tiny" title="Dynamische Inhalte anzeigen und bearbeiten" circular onClick={this.toggle}><Icon name="edit" /> Seite bearbeiten</Button>}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/CMSIntegration.js